var firebaseConfig = {
    apiKey: "AIzaSyCI9wCRenFdsTintBXquuNjSPMSM5m_Wnk",
    authDomain: "city-ride-89648.firebaseapp.com",
    projectId: "city-ride-89648",
    storageBucket: "city-ride-89648.appspot.com",
    messagingSenderId: "263054740574",
    appId: "1:263054740574:web:1cee77b972c9542a6a38cf"
  };

export default firebaseConfig;